export default {
	tabs: {
		interviewRanking: 'تقييم المقابلة',
		employeePerformance: 'أداء الموظف',
	},
};
